import FeatureCallout from './feature_callout';

export default FeatureCallout;
